import React, {Component} from "react";
import {connect} from 'react-redux';


import styled from 'styled-components'
import {borderRight} from "styled-system";
import {Box, Card, Flex} from "rebass";
import {Avatar, Divider} from "reakit";
import {CardTitle, MetaText} from "../Base/Text";
import {withFirebase} from "../Firebase";
import moment from 'moment'
import Truncate from 'react-truncate';
import {chatSelectors} from "../../store/chat";

// This component is used on the Main chat screen as the clickable chat cards to open a chat
// props needed: item - current chat and profile

const ChatAlert = styled(Flex)`
  justify-content: center;
  align-items: center;
  align-content: center;
  text-align: center;
  vertical-align: middle;
  border-radius: 50px;
  background-color: ${props => props.theme.colors.purple};
  font-size: 0.8em;
  height: 1.8em;
  width: 1.8em;
  color: white;
`;

const StyledCard = styled(Card)`
min-width: 275px;
font-weight: 700;
${borderRight}
`;

const cardProps = {
	p: 2
};

class ChatCard extends Component {
	_isMounted = false
	state = {
		members: []
	};

	componentDidMount() {
		this._isMounted = true
		this.fetchUserDetails()
	}

	fetchUserDetails = async () => {
		const {item, profile} = this.props;
		let ids = [];
		let members = [];
		if (item.members.includes(item.creator_uid)) {
			ids = item.members
		} else {
			ids = [item.creator_uid, ...item.members]

		}


		try {
			// let studentRef = await this.props.firebase.students()
			// let facultyRef = await this.props.firebase.faculties()
			for (let i in ids) {
				if (ids[i] !== profile.id) {
					if (ids[i].length === 7) {
						let student = await this.props.firebase.student(ids[i]).get();
						members.push({id: student.id, ...student.data()})
					} else {
						let faculty = await this.props.firebase.faculty(ids[i]).get();
						members.push({id: faculty.id, ...faculty.data()})
					}
				}
			}
			this._isMounted && this.setState({members})

		} catch (error) {
			//console.log(error)
		}
	};


	handleCardClick = () => {
		const {members} = this.state;
		let {handleClick, item} = this.props;
		item.members = members;

		handleClick(item)

	};

	showLastMessage = () => {
		const {item, profile } = this.props;

		let showLastMessage = false
		if(profile.id !== item.creator_uid){
			if(item.is_group === true){
				if(item.accepted && item.accepted.members && item.accepted.members.includes(profile.id)){
					showLastMessage = true
				}
			} else {
				if(item.accepted.status === 1){
					showLastMessage = true
				}

			}
		} else {
			showLastMessage = true
		}

		if(item.creator_uid.length === 4){
			showLastMessage = true
		}
		return showLastMessage
	}

	renderMessage = () => {

		let message = ''
		const {item, profile} = this.props;
		const {messages} = item;

		const showLastMessage = this.showLastMessage()
		if(profile.id !== item.creator_uid){
			if(item.is_group === true){
				if(item.accepted && item.accepted.members && !item.accepted.members.includes(profile.id)){
					message = 'Group Chat Request'
				}
			} else {
				if(item.accepted.status === 0){
					message = "New Message Request"
				}
				if(item.accepted.status === 2){
					message = "Declined Message Request"
				}
			}
		}
		if(showLastMessage){
			let lastMessage = {message: ''};
			if (messages.length > 0) {
				lastMessage = messages[messages.length - 1];

			}
			message = lastMessage.message
		}
		return message
	}

	componentWillUnmount() {
		this._isMounted = false
	}

	render() {
		const {members} = this.state;
		const {item, profile, currentChat} = this.props;
		const {messages} = item;
		let newCount = 0;
		// let newMessages = false;
		if (messages.length > 0) {
			for (let i in messages) {
				// console.log(i)
				if (!messages[i].seen.includes(profile.id)) {
					newCount++;
				}
			}
		}
		// if (newCount > 0) {
		// 	newMessages = true
		// }
		let lastMessage = {message: ''};
		let lastDate = '';
		if (messages.length > 0) {
			lastMessage = messages[messages.length - 1];

			lastDate = moment.unix(lastMessage.created_at).fromNow();

		}
		const nameList = members.map((member, i) => i > 0 ? (member.first_name + ' ' + member.last_name) : (member.first_name + ' ' + member.last_name));
		let chatTitle = nameList.join(', ');
		if (item.is_group) {
			if(item.name !== ''){
				chatTitle = `${item.name} (${members.length})`

			} else {
				chatTitle = `Group Chat (${members.length})`

			}
		}

		let rightBorder = ['none','7px solid transparent']
		if(currentChat === item.id){
			rightBorder = ['none','7px solid #2b80b9']
		}

		const showLastMessage = this.showLastMessage()
		return (
			<Box>
				<StyledCard variant='chat' {...cardProps} onClick={this.handleCardClick} borderRight={rightBorder}>
					<Flex py={2} pl={2}>
						<Box mr={1} width={'18%'}>
							<Avatar width={'43px'} height={'43px'} backgroundColor={'#707070'} src={members[0] && members[0].profile_pic}/>
						</Box>
						<Box p={1} width={'57%'}>
							<CardTitle>
								<Truncate
									lines={1}
									ellipsis='...'
								>
									{chatTitle}
								</Truncate>
							</CardTitle>
							<MetaText fontWeight={700}>
								<Truncate
									lines={1}
									ellipsis='...'
								>
									{this.renderMessage()}
								</Truncate>
							</MetaText>
						</Box>
						<Flex flexDirection={'column'} width={'25%'}>
							<Box>
								<MetaText fontWeight={700} fontSize={'11px'}>{lastDate}</MetaText>
							</Box>
							<Flex>
								<Box ml={'auto'}/>
								<Box>
									{showLastMessage && newCount > 0 ? <ChatAlert mt={1} bg='purple' color="white">{showLastMessage && newCount}</ChatAlert> : <Box/>}
								</Box>
							</Flex>
						</Flex>
					</Flex>
					<Box width={1} m={0}><Divider padding={0} margin={0}/></Box>

				</StyledCard>
			</Box>
		)
	}

}

const mapStateToProps = (state) => ({
	currentChat: chatSelectors.refreshCurrentID(state.chat)

});



export default withFirebase(connect(
	mapStateToProps)(ChatCard))

